import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITableSettings } from './interfaces/table-settings.interface';

@Component({
  selector: 'sgt-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  private defaultSettings: ITableSettings = {
    loading: true,
    isEmpty: true,
    showDisplayCounterRecords: true,
  };

  @Input() className?: string;
  @Input() id?: string | number;
  @Input() settings!: ITableSettings;

  @Output() scrollBottom = new EventEmitter<void>();

  private hasReachedBottom = false;

  ngOnInit(): void {
    this.settings = {
      ...this.defaultSettings,
      ...this.settings,
    };
  }

  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    const limitToScroll = 50;
    const isNearBottom =
      element.scrollTop + element.clientHeight >=
      element.scrollHeight - limitToScroll;

    if (this.settings?.loading) {
      return;
    }

    this.handleScrollBottom(isNearBottom);
  }

  private handleScrollBottom(isNearBottom: boolean): void {
    if (isNearBottom && !this.hasReachedBottom) {
      this.hasReachedBottom = true;
      this.scrollBottom.emit();
    } else if (!isNearBottom && this.hasReachedBottom) {
      this.hasReachedBottom = false;
    }
  }
}
